// src/components/ErrorBoundary/ErrorBoundary.jsx

import React, { Component } from 'react';
import { withTranslation } from 'react-i18next'; // 1. Import the HOC
import "./ErrorBoundary.css";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    // 2. Access the 't' function from props
    const { t } = this.props;

    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          {/* 3. Use the t function with your keys */}
          <h2>{t('errorBoundary.title')}</h2>
          <p>{t('errorBoundary.message')}</p>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

// 4. Wrap the component with the HOC on export
export default withTranslation()(ErrorBoundary);